import { render, staticRenderFns } from "./shelf.vue?vue&type=template&id=ce248d58&functional=true"
import script from "./shelf.vue?vue&type=script&lang=js"
export * from "./shelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports